import React from "react";
import { Nav } from "shards-react";

import { UserContextConsumer } from "../../../../backend/userContext";
import UserActions from "./UserActions";

export default () => (
  <UserContextConsumer>
    {(props) => {
      return (
        <Nav navbar className="border-left ml-auto">
          {/*  <Notifications user={props}/> */}
          <UserActions user={props} />
        </Nav>
      );
    }}
  </UserContextConsumer>
);
